import { supabase } from '../supabaseClient';

/**
 * 更新 ticket 的最後活動時間與操作者
 * 所有會改動 ticket 相關資料的操作，結尾都應呼叫此函式
 *
 * @param {number|string} ticketId
 * @param {string} actorId - 執行操作的人的 user_id
 */
export const updateTicketActivity = async (ticketId, actorId) => {
  if (!ticketId) return;

  const updatePayload = { last_activity_at: new Date().toISOString() };
  if (actorId) {
    updatePayload.last_activity_by = actorId;
  }

  const { error } = await supabase
    .from('tickets')
    .update(updatePayload)
    .eq('id', ticketId);

  if (error) {
    console.error('Failed to update ticket activity:', error);
  }
};
